import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { InaService } from './ina.service';
import { InaController } from './ina.controller';
import { LineEntity } from '../entities/line.entity';
import { OperationEntity } from '../entities/operation.entity';
import { OperatorEntity } from '../entities/operator.entity';
import { ShiftEntity } from '../entities/shift.entity';
import { OperatorEfficiencyDayTrackEntity } from '../entities/transactions/operator-efficiency-track.entity';
import { LineActualDayTrackEntity } from '../entities/transactions/line-actual-track.entity';
import { LineEfficiencyDayTrackEntity } from '../entities/transactions/line-efficiency.entity';
import { LineDayPlanEntity } from '../entities/transactions/line-plan';
import { StyleOperationsEntity } from '../entities/style-operations.entity';
import { UnitEntity } from '../entities/unit.entity';
import { WorkstationEntity } from '../entities/workstation.entity';
import { StyleEntity } from '../entities/style.entity';
import { LineDownTimeEntity } from '../entities/transactions/line-down-time.entity';
import { ReasonEntity } from '../entities/reason.entity';
import { UnitBreakEntity } from '../entities/unit-break.entity';
import { UnitDayBreakEntity } from '../entities/unit-day-break.entity';
import { UnitDayHourEntity } from '../entities/unit-day-hours.entity';
import { MigrationModule } from '../migration/migration.module';
import { InaHelperService } from './ina.helper.service';
import { InaImageService } from './ina-image.service';
import { CentralInaInfoService } from './central-ina-info.service';
import { LineTargetEffEntity } from '../entities/line-target-eff.entity';

@Module({
  imports: [
      TypeOrmModule.forFeature([
          UnitEntity,
          UnitDayHourEntity,
          UnitBreakEntity,
          UnitDayBreakEntity,
          ShiftEntity,
          StyleEntity,
          OperationEntity,
          OperatorEntity,
          LineEntity,
          WorkstationEntity,
          StyleOperationsEntity,
          LineDayPlanEntity,
          LineActualDayTrackEntity,
          LineEfficiencyDayTrackEntity,
          OperatorEfficiencyDayTrackEntity,
          LineDownTimeEntity,
          ReasonEntity,
          LineTargetEffEntity
      ]),
      MigrationModule
  ],
  controllers: [InaController],
  providers: [InaService, InaHelperService, InaImageService, CentralInaInfoService],
  exports:[InaService, InaHelperService]
})
export class InaModule { }
